export default "/images/ellipse.svg?bd4b532e7d222ed44ba4c1e932698c19";